import { render, staticRenderFns } from "./start-session.vue?vue&type=template&id=00724b30&"
import script from "./start-session.vue?vue&type=script&lang=ts&"
export * from "./start-session.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports